/* global window */

function getItem(key) {
	if (!hasLocalStorage())
		return null;

	const value = window.localStorage.getItem(key);

	return value ? JSON.parse(value) : null;
}

function removeItem(key) {
	if (hasLocalStorage())
		window.localStorage.removeItem(key);
}

function setItem(key, value) {
	if (!hasLocalStorage())
		return;

	window.localStorage.setItem(key, JSON.stringify(value));
}

let localStorageResult = void 0;

function hasLocalStorage() {
	if (localStorageResult !== void 0)
		return localStorageResult;

	if (!window)
		return (localStorageResult = false);

	if (typeof window.localStorage !== 'undefined') {
		try {
			window.localStorage.setItem('feature_test', 'yes');

			if (window.localStorage.getItem('feature_test') === 'yes') {
				window.localStorage.removeItem('feature_test');

				return (localStorageResult = true);
			}
		} catch (error) { /**/ }
	}

	return (localStorageResult = false);
}

module.exports = { getItem, removeItem, setItem };
